<template>
  <div class="model_continer">
    <p class="dataAnalysisTitle">ARMA 模型（自回归滑动平均模型）</p>
    <p
      class="introl"
    >简介： ARMA模型是统计模型中最常见的一种用来进行时间序列单变量预测的模型。由自回归模型（简称 AR 模型）与移动平均模型（简称 MA 模型）为基础“混合”构成。建模和检验步骤与 AR 模型类似，这里只给出 ARMA 模型公式。</p>
    <div class="introl">
      <span>ARMA 模型公式：</span>
      <img src="../../assets/image/gs.png" alt="" srcset="">
      <!-- <span style="position: relative;font-family: serif;">
        <span>𝑋𝑡 = 𝛽0 +∑𝛽𝑖𝑋𝑡−𝑖 + 𝜀𝑡 +∑𝛼𝑗ℎ𝑡−𝑗 </span>
      </span> -->
      <!-- <p class="introl" style="margin-top: -10px;font-family: serif;">
        <span style="display: inline-block;padding-left: 188px">I</span>
        <span style="display: inline-block;padding-left: 119px;">I</span>
        <span style="display: inline-block;padding-left: 182px;">I</span>
      </p> -->
    </div>
    <p class="modelApplyLittleTitle">
      <span>第1步：</span>
      <span>选择预测数据的关键指标字段</span>
    </p>
    <!--本地预测-->
    <label>
      <div class="modelApplyScreen">
        <label>下载模板：</label>
        <a :href="template1">价格模板</a>
        <!-- ipUrl -->
      </div>
      <div class="modelApplyScreen">
        <label>预测步长：</label>
        <el-input v-model="step" placeholder="请输入步长"></el-input>
      </div>
      <div class="modelApplyScreen">
        <label>上传数据：</label>
        <el-input v-model="localFileName" placeholder="请选择文件" :readonly="readonly" />
        <span class="screen-upload-btn">
          <input type="file" accept=".xls, .xlsx" @change="uploadFileBtn" class="inputFile" />
          <i class="el-icon-upload2"></i>
          数据上传
        </span>
      </div>
      <div class="modelApplyScreen">
        <label style="width: 80px;text-align:right;display:inline-block">区域：</label>
        <el-select v-model="localProvinceValue" placeholder="选择城市" @change="localProvinceChage">
          <el-option
            v-for="(item, index) in localProvinceList"
            :key="index"
            :label="item"
            :value="item"
          ></el-option>
        </el-select>
      </div>
      <div class="modelApplyScreen">
        <label style="width: 80px; text-align: right; display: inline-block">来源：</label>
        <el-select v-model="localMarketValue" placeholder="选择来源" @change="localMarkListChang">
          <el-option
            v-for="(item, index) in localMarkList"
            :key="index"
            :label="item.name"
            :value="item.name"
          ></el-option>
        </el-select>
      </div>
      <div class="modelApplyScreen">
        <label>品种：</label>
        <el-select v-model="localCategoryValue" placeholder="选择品种" @change="categoryChange">
          <el-option
            v-for="(item, index) in localCategoryList"
            :key="index"
            :label="item"
            :value="item"
          ></el-option>
        </el-select>
      </div>
      <p style="font-size: 12px; width: 50%; color: red">
        <!-- 注意：选择品种最多选择5类胶类进行预测，超出规定数量将不能显示预测效果 -->
      </p>
    </label>

    <p class="modelApplyLittleTitle">
      <span>第2步：</span>
      <span>点击分析查看预测的数据指标</span>
      <el-button class="greenBtn" @click="forecasBtn">分析</el-button>
    </p>
    <div class="modelApplyTable">
      <el-table :data="thiredMarketPriceList" border style="width: 100%">
        <el-table-column prop="province" label="城市"></el-table-column>
        <el-table-column prop="varieties" label="类别"></el-table-column>
        <el-table-column prop="market" label="市场名称"></el-table-column>
        <el-table-column prop="pubDate" label="日期"></el-table-column>
        <el-table-column prop="maxPrice" label="最高价格（元）"></el-table-column>
        <el-table-column prop="minPrice" label="最低价格（元）"></el-table-column>
        <el-table-column prop="avgPrice" label="平均价格（元）"></el-table-column>
      </el-table>
    </div>
    <div style="clear: both"></div>
    <div id="targetChart" class="targetChart"></div>
  </div>
</template>

<script>
import {
  getAreaNameList,
  getVarietiesList,
  getMarketList,
  forecastPrice,
  getMarketPriceList,
  localForecastPriceModel,
  uploadFile
} from "../../utils/api/priceForecast";
export default {
  name: "",
  data() {
    return {
      template1: `${this.templateUrl}/价格.xlsx`,
      readonly: true,
      //城市下拉数据
      areaNameList: [],
      //类别下拉数据
      categoryList: [],
      //市场下拉数据
      marketList: [],
      thiredMarketPriceList: [], //  第三步 市场列表数据
      overYearMarketPriceList: [], // 第二部 历年数据预测
      provinceValue: "", //城市下拉
      categoryValue: "", //类别下拉
      marketValue: "", //市场下拉
      step: "", //步长
      currentPage: 1, // 当前页
      pageSize: 10, // 每页显示多少条
      total: 0, // 总计数量
      dataSoruce: "history",
      localFileName: "", // 文件名称
      localFileUrl: "", // 文件路径
      localProvinceValue: "", // 本地预测地区值
      localProvinceList: [], // 本地预测地区列表
      localMarketValue: "", // 本地市场值
      localMarkList: [], // 本地市场列表
      queryParams: [], // 市场及总类列表
      localCategoryList: [], // 本地种类
      localCategoryValue: "", // 种类
      // 数据来源数据
      dataSoruceList: [
        {
          label: "本地数据",
          value: "local"
        },
        {
          label: "历史数据",
          value: "history"
        }
      ]
    };
  },
  methods: {
    // 上传本地文件
    uploadFileBtn(evt) {
      if (!this.step) {
        this.$message({
          message: "请输入预测步长",
          type: "warning"
        });
        return;
      }
      this.localFileName = evt.target.files[0].name;
      this.uploadFile(evt.target.files[0]);
    },
    // 上传文件接口
    async uploadFile(file) {
      let formdata = new FormData();
      formdata.append("file", file);
      let res = await uploadFile(formdata);
      this.localFileUrl = res.data;
      // 根据文件获取地区列表
      this.getAreaListByFile();
    },
    // 切换数据来源
    dataSoruceChange(value) {
      this.localFileName = ""; // 文件名称清空
      this.localFileUrl = ""; // 文件路径清空\
      this.step = ""; // 步长清空
      this.thiredMarketPriceList = []; // 最后一步预测 列表数据清空
      this.drawChart([], [], [], []);
      // 历史数据 地区默认显示列表第一个
      if (value === "history") {
        this.provinceValue = this.areaNameList[0];
      } else {
        this.provinceValue = "";
      }
    },
    // 获取地区列表
    async getAreaNameList() {
      let res = await getAreaNameList();
      if (res.data.code === 0) {
        this.areaNameList = res.data.data;
        this.provinceValue = this.areaNameList[0]; // 地区默认第一个
        this.getMarketList();
      }
    },

    // 获取 橡胶种类列表
    async getVarietiesList() {
      let params = {
        province: '福安',//this.provinceValue,
        market: this.marketValue
      };
      let res = await getVarietiesList(params);
      if (res.data.code === 0) {
        this.categoryList = res.data.data;
        this.categoryValue = this.categoryList[0]; // 默认种类为列表第一个
        // this.getMarketList(); // 获取市场列表
      }
    },

    // 城市change
    provinceChage(value) {
      this.provinceValue = value;
      this.categoryValue = ""; // 改变城市时将种类清空
      this.marketValue = ""; // 改变城市时清空批发市场value
      this.getMarketList(); // 获取批发市场列表
    },
    // 本地预测  地区change
    localProvinceChage(value) {
      this.localProvinceValue = value;
      // 获取 市场列表
      for (let i = 0; i < this.queryParams.length; i++) {
        if (this.localProvinceValue === this.queryParams[i].key) {
          this.localMarkList = this.queryParams[i].market;
        }
      }
    },
    // 改变类别列表
    categoryChange(value) {
      this.categoryValue = value;
      // this.marketValue = ""; // 修改种类时清空批发市场value
    },
    // 改变市场获取种类
    changeMarket(value) {
      this.marketValue = value;
      this.getVarietiesList(); // 根据地区,市场获取种类
    },

    // 获取批发市场查询条件列表
    async getMarketList() {
      let params = {
        //varieties: this.categoryValue, // 橡胶种类
        province: this.provinceValue // 地区
      };
      let res = await getMarketList(params);
      if (res.data.code === 0) {
        this.marketList = res.data.data;
        this.marketValue = this.marketList[0]; // 默认种类为列表第一个
        this.getVarietiesList(); // 获取种类列表(); // 第二步  历年数据预测
      }
    },
    // 第二步  历年数据预测
    async getMarketPriceList() {
      let params = {
        market: this.marketValue, // 市场
        // number: this.step, // 步长
        province: this.provinceValue, // 地区
        varieties: this.categoryValue, // 橡胶种类
        currentPage: this.currentPage, // 当前页
        pageSize: this.pageSize // 每页显示多少条
      };
      let res = await getMarketPriceList(params);
      if (res.data.code === 0) {
        this.overYearMarketPriceList = res.data.data.records;
        this.total = res.data.data.total;
      }
    },
    // 分页
    currentChange(value) {
      this.currentPage = value;
      this.getMarketPriceList();
    },
    // 点击分析
    forecasBtn() {

        this.localForecastPriceModel();
      
    },
    // 第三步  价格预测
    async forecastPrice() {
      if (!this.step) {
        this.$message({
          message: "请输入预测步长",
          type: "warning"
        });
        return;
      }
      let params = {
        market: this.marketValue, // 市场
        number: this.step, // 步长
        province: this.provinceValue, // 地区
        varieties: this.categoryValue // 橡胶种类
      };
      let res = await forecastPrice(params);
      if (res.data.code === 0) {
        this.thiredMarketPriceList = res.data.data.marketPriceList;
        this.drawChart(
          res.data.data.dateList,
          res.data.data.realMaxList,
          res.data.data.realMinList,
          res.data.data.realAvgList,
          res.data.data.forecastMaxList,
          res.data.data.forecastMinList,
          res.data.data.forecastAvgList
        );
      }
    },
    // 本地市场列比change
    localMarkListChang(value) {
      for (let i = 0; i < this.localMarkList.length; i++) {
        if (value === this.localMarkList[i].name) {
          this.localCategoryList = this.localMarkList[i].type;
        }
      }
    },
    // 根据上传文件获取 地区列表
    async getAreaListByFile() {
      let params = {
        file: this.localFileUrl, // 文件路径
        step: this.step // 步长
      };
      let res = await localForecastPriceModel(params);
      if (res.data.code === 0) {
        this.localProvinceList = res.data.data.areaList; // 地区列表
        this.queryParams = res.data.data.param; // 市场及种类列表
        // 获取 市场列表
        for (let i = 0; i < res.data.data.param.length; i++) {
          for (let j = 0; j < res.data.data.param[i].market.length; j++) {
            this.localMarkList.push({
              name: res.data.data.param[i].market[j].name
            });
          }
        }
      }
    },
    // 本地预测
    async localForecastPriceModel() {
      let params = {
        file: this.localFileUrl, // 文件路径
        market: this.localMarketValue, // 市场
        step: this.step, // 步长
        area: this.localProvinceValue, // 地区
        type: this.localCategoryValue // 橡胶种类
      };
      let res = await localForecastPriceModel(params);
      if (res.data.code === 0) {
        this.thiredMarketPriceList = res.data.data.data[0].marketPriceList;
        this.drawChart(
          res.data.data.data[0].dateList,
          res.data.data.data[0].realMaxList,
          res.data.data.data[0].realMinList,
          res.data.data.data[0].realAvgList,
          res.data.data.data[0].forecastMaxList,
          res.data.data.data[0].forecastMinList,
          res.data.data.data[0].forecastAvgList
        );
      }
    },
    // 折线图 图表显示
    drawChart(
      dateList,
      realMaxList,
      realMinList,
      realAvgList,
      forecastMaxList,
      forecastMinList,
      forecastAvgList
    ) {
      let myChart = this.$echarts.init(document.getElementById("targetChart"));
      let option = {
        tooltip: {
          trigger: "axis",
          transitionDuration: 0
        },
        dataZoom: [
          {
            type: "slider",
            show: true,
            height: 20,
            left: "10%",
            right: "10%",
            bottom: "2%",
            start: 0,
            end: 100,
            zoomLock: true,
            zoomOnMouseWheel: false,
            moveOnMouseMove: false,
            textStyle: {
              color: "#d4ffff",
              fontSize: 11
            }
          },
          {
            type: "inside"
          }
        ],
        grid: {
          top: "10%",
          left: "5%",
          right: "0%",
          bottom: "15%"
          // containLabel: true
        },
        legend: {
          show: true
        },
        xAxis: [
          {
            type: "category",
            axisLabel: {
              show: true,
              textStyle: {
                color: "#666",
                fontSize: 12
              }
              // formatter: '{value} 台'
            },
            axisTick: {
              show: false
            },
            splitLine: {
              show: false
            },
            axisLine: {
              lineStyle: {
                color: "#eee"
              }
            },
            // boundaryGap: false,
            data: dateList
          }
        ],

        yAxis: [
          {
            name: "价格/元",
            type: "value",
            // min: 0,
            // max: 140,
            // splitNumber: 4,
            splitLine: {
              show: true,
              lineStyle: {
                color: "#eee"
              }
            },
            axisLine: {
              show: false
            },
            axisLabel: {
              show: true,
              textStyle: {
                color: "#666",
                fontSize: 12
              }
              // formatter: '{value} 台'
            },
            axisTick: {
              show: false
            }
          }
        ],
        series: [
          {
            name: "历史最高价格",
            type: "line",
            smooth: true,
            symbolSize: 6,
            itemStyle: {
              normal: {
                color: "#F5C228"
              }
            },

            data: realMaxList
          },
          {
            name: "历史最低价格",
            type: "line",
            smooth: true,
            symbolSize: 6,
            itemStyle: {
              normal: {
                color: "#719DF9"
              }
            },

            data: realMinList
          },
          {
            name: "历史平均价格",
            type: "line",
            smooth: true,
            symbolSize: 6,
            itemStyle: {
              normal: {
                color: "#66DBAE"
              }
            },

            data: realAvgList
          },
          {
            name: "预测最高价格",
            type: "line",
            smooth: true,
            symbolSize: 6,
            itemStyle: {
              normal: {
                color: "#F5C228",
                lineStyle: {
                  width: 2,
                  type: "dotted" //'dotted'虚线 'solid'实线
                }
              }
            },

            data: forecastMaxList
          },
          {
            name: "预测最低价格",
            type: "line",
            smooth: true,
            symbolSize: 6,
            itemStyle: {
              normal: {
                color: "#719DF9",
                lineStyle: {
                  width: 2,
                  type: "dotted" //'dotted'虚线 'solid'实线
                }
              }
            },

            data: forecastMinList
          },
          {
            name: "预测平均价格",
            type: "line",
            smooth: true,
            symbolSize: 6,
            itemStyle: {
              normal: {
                color: "#66DBAE",
                lineStyle: {
                  width: 2,
                  type: "dotted" //'dotted'虚线 'solid'实线
                }
              }
            },

            data: forecastAvgList
          }
        ]
      };
      myChart.setOption(option);
    }
  },
  mounted() {
    // this.getAreaNameList(); // 获取地区列表
    this.drawChart();
  }
};
</script>

<style lang="scss" scoped>
.model_continer {
  margin-left: 30px;
}
.introl {
  color: #999;
  font-size: 14px;
  line-height: 22px;
  margin-top: 10px;
  display: flex;
  align-items: center;
  img{
    height: 60px;
  }
}
.modelApplyLittleTitle {
  margin: 20px 0;
}
span:nth-child(1) {
  font-weight: bold;
}
.modelApplyLittleTitle span:nth-child(2) {
  color: #333;
}
.modelApplyScreen {
  display: inline-block;
  margin-right: 15px;
  margin-bottom: 15px;
  // width: 20%;
  label {
    color: #999;
  }
  a {
    color: #333;
    font-size: 14px;
    text-decoration: underline;
  }
}
.greenBtn {
  padding: 6px 12px;
  font-size: 16px;
  letter-spacing: 1px;
  background: #59a6a0;
  border: 1px solid #59a6a0;
  color: #fff;
  margin-left: 30px;
}
.greenBtn:focus,
.greenBtn:hover {
  background: #39a1a6;
  border: 1px solid #39a1a6;
}
.targetChart {
  margin-top: 10px;
  width: 100%;
  height: 400px;
}
.screen-upload-btn {
  width: 100px;
  margin-bottom: 0;
  margin-top: 0;
  position: relative;
  font-size: 14px;
  color: #999;
  .inputFile {
    position: absolute;
    width: 100px;
    left: 0px;
    height: 30px;
    opacity: 0;
  }
}

.dataAnalysisTitle {
  font-size: 18px;
}
</style>